import Vue from "vue";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

import store from "@/store";
import vuetify from "@/plugins/vuetify";
import router from "@/router";
import App from "@/App.vue";
import "./assets/scss/style.scss";

Vue.config.productionTip = false;

const config = {
  apiKey: "AIzaSyC9KMqkD0ZpTDT5CiKikvz-rZERFn-ltgc",
  authDomain: "spektrax-prd.firebaseapp.com",
  databaseURL: "https://spektrax-prd.firebaseio.com",
  projectId: "spektrax-prd",
  storageBucket: "spektrax-prd.appspot.com",
  messagingSenderId: "642005369188",
  appId: "1:642005369188:web:82d16d6c3b454593093a71"
};
firebase.initializeApp(config);

firebase.auth().onAuthStateChanged(async function(user) {
  if (!user) {
    console.info("No authenticated user found.");
    await store.dispatch("auth/clearUser");
    return false;
  }

  await store.dispatch("auth/setUser", { user });
});

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount("#app");
